// extracted by mini-css-extract-plugin
module.exports = {"langWrap":"langWrap_2WcwDOYH","iconEarth":"iconEarth_hAFgcUNc","iconArrow":"iconArrow_eE5imzjS","langSelectWrap":"langSelectWrap_kJxZpc5q","langItem":"langItem_2WRBVzAD"};